import Vue from 'vue'
import { localLoad, localStore } from './storageService'


export const RTL_LOCALES = Object.freeze(['he', 'ar'])

export const localeData = {
    language: 'en',
    isRTL: false
}

/**
 * @param {string|undefined} language
 * @returns {string}
 */
export function normalizeLanguage(language) {
    return String(language || 'en')
        .trim()
        .toLowerCase()
        .split(/[-_]/)[0]
}

/**
 * @param {string|undefined} language
 * @returns {boolean}
 */
export function isRtlLocale(language) {
    return RTL_LOCALES.includes(normalizeLanguage(language))
}

/**
 * Calendar week start for vue-material md-datepicker.
 * 0 = Sunday, 1 = Monday (JS Date.getDay convention).
 * Hebrew/Israel: Sunday (work week starts Sunday). English and other locales: Monday.
 */
function getFirstDayOfAWeek(language) {
    if (language === 'he') return 0
    return 1
}

function applyDatePickerWeekStart(language) {
    if (!Vue.material || !Vue.material.locale) return
    Vue.material.locale.firstDayOfAWeek = getFirstDayOfAWeek(language)
}

export function updateLocaleData(language) {
    if (!language) {
        language = localLoad('language') || 'en'
    }
    localeData.language = language
    localStore("language", language);

    localeData.isRTL = isRtlLocale(language)
    applyDatePickerWeekStart(language)
}